import { BM } from './backend';
import { performanceMeasureEnd, performanceMeasureStart } from './dev_tools';
import { Element } from './element';
import { ENV } from './global_options';
import { VIRTUAL_NODE_SYMBOL, isVirtualNode } from './type_symbol';
export class VirtualNode extends Element {
    /* @internal */
    /* istanbul ignore next */
    constructor() {
        throw new Error('Element cannot be constructed directly');
        // eslint-disable-next-line no-unreachable
        super();
    }
    /* @internal */
    _$initializeVirtual(virtualName, owner, nodeTreeContext) {
        const is = String(virtualName);
        if (nodeTreeContext &&
            (BM.SHADOW || (BM.DYNAMIC && nodeTreeContext.mode === 1 /* BackendMode.Shadow */))) {
            const shadowRoot = owner._$backendShadowRoot;
            if (ENV.DEV)
                performanceMeasureStart('backend.createVirtualNode');
            const be = shadowRoot.createVirtualNode(virtualName);
            if (ENV.DEV)
                performanceMeasureEnd();
            this._$initialize(is, true, be, owner, nodeTreeContext);
            if (ENV.DEV)
                performanceMeasureStart('backend.associateValue');
            be.__wxElement = this;
            be.associateValue(this);
            if (ENV.DEV)
                performanceMeasureEnd();
        }
        else {
            this._$initialize(is, true, null, owner, owner._$nodeTreeContext);
        }
    }
    /* @internal */
    static create(virtualName, owner) {
        const node = Object.create(VirtualNode.prototype);
        node._$initializeVirtual(virtualName, owner, owner.getBackendContext());
        return node;
    }
}
VirtualNode.isVirtualNode = isVirtualNode;
VirtualNode.prototype[VIRTUAL_NODE_SYMBOL] = true;
//# sourceMappingURL=virtual_node.js.map